import { Descriptions } from "antd"
import React, { memo, useEffect, useMemo } from "react";
import { TaxCodeInfoModel } from "../../../../../model/searchInvoiceModels";
import useSearchInvoiceService from "../../../../../helper/services/searchInvoiceServices";

const TaxCodeInfo: React.FC<{ taxCode: string }> = ({ taxCode }) => {
    const searchInvoiceService = useSearchInvoiceService();
    useEffect(() => {
        if(!taxCode) return;
        searchInvoiceService.getTaxCodeInfo(taxCode)
            .then((response) => {
                setTaxCodeInfo(response);
            })
    }, [taxCode])

    const [taxCodeInfo, setTaxCodeInfo] = React.useState<TaxCodeInfoModel | null>();
    return (<Descriptions size="small" column={1} bordered>
        <Descriptions.Item label="Tên công ty" contentStyle={{ textAlign: "justify" }}>
            {taxCodeInfo?.ten_cty}
        </Descriptions.Item>
        <Descriptions.Item label="Mã số thuế" contentStyle={{ textAlign: "justify" }}>
            {taxCodeInfo?.ma_so_thue}
        </Descriptions.Item>
        <Descriptions.Item label="Ngày thành lập" contentStyle={{ textAlign: "justify" }}>
            {taxCodeInfo?.ngay_thanh_lap}
        </Descriptions.Item>
        <Descriptions.Item label="Người đại diện" contentStyle={{ textAlign: "justify" }}>
            {taxCodeInfo?.nguoi_dai_dien}
        </Descriptions.Item>
        <Descriptions.Item label="Địa chỉ" contentStyle={{ textAlign: "justify" }}>
            {taxCodeInfo?.dia_chi}
        </Descriptions.Item>
        <Descriptions.Item label="CQT quản lý" contentStyle={{ textAlign: "justify" }}>
            {taxCodeInfo?.cqthue_ql}
        </Descriptions.Item>
        <Descriptions.Item label="CQT cấp tỉnh" contentStyle={{ textAlign: "justify" }}>
            {taxCodeInfo?.cqthuecap_tinh}
        </Descriptions.Item>
    </Descriptions>)
}
export default memo(TaxCodeInfo)